import { getLocalDateString } from '~/utils';

export interface PurchaseOrderDates {
  shipWeekDate: string;
  promiseDate: string;
  dueByDate: string;
}

export const PURCHASE_ORDER_DATE_FIELDS = [
  'shipWeekDate',
  'promiseDate',
  'dueByDate',
] as const;

export const EMPTY_PURCHASE_ORDER_DATES: PurchaseOrderDates = {
  shipWeekDate: '',
  promiseDate: '',
  dueByDate: '',
};

export type PurchaseOrderDateField =
  (typeof PURCHASE_ORDER_DATE_FIELDS)[number];

export type PurchaseOrderDateError = 'in_past' | 'out_of_order';

/** Ship week, promise and due by follow one another, and none is before today. */
export function earliestPurchaseOrderDate(
  field: PurchaseOrderDateField,
  dates: PurchaseOrderDates,
  today: string
): string {
  return PURCHASE_ORDER_DATE_FIELDS.slice(
    0,
    PURCHASE_ORDER_DATE_FIELDS.indexOf(field)
  ).reduce(
    (earliest, previous) =>
      dates[previous] > earliest ? dates[previous] : earliest,
    today
  );
}

export function purchaseOrderDateError(
  field: PurchaseOrderDateField,
  dates: PurchaseOrderDates,
  today: string
): PurchaseOrderDateError | null {
  const date = dates[field];
  if (date === '') return null;
  if (date < today) return 'in_past';
  if (date < earliestPurchaseOrderDate(field, dates, today)) {
    return 'out_of_order';
  }
  return null;
}

export function arePurchaseOrderDatesComplete(
  dates: PurchaseOrderDates,
  today: string = getLocalDateString()
): boolean {
  return PURCHASE_ORDER_DATE_FIELDS.every(
    (field) =>
      dates[field] !== '' &&
      purchaseOrderDateError(field, dates, today) === null
  );
}
